<template>
    <div class="pa-4">

        <div class="text-body-1 py-3">Введите {{ hasEmail ? '' : 'новый'}} адрес электронной почты.</div>

        <sg-text-field ref="email" v-model="newEmail" type="email" class="hide-numbers" label="Адресс электронной почты"
            autofocus autocomplete="off" @paste.prevent.stop :rules="newEmailRules"
            @keyup.enter.stop.prevent="startChangeEmail" @keydown.tab.stop.prevent="startChangeEmail" />

        <div class="d-flex mt-3">
            <v-btn color="primary" depressed @click.stop="startChangeEmail" :disabled="!nextEnabled">
                Далее
            </v-btn>
            <v-btn class="ml-3" color="primary" text @click.stop="goBack">Отмена</v-btn>
            <v-spacer />
        </div>

    </div>
</template>

<script>
    import emailMixin from './emailMixin'

    export default {

        mixins: [emailMixin],

        computed: {
            nextEnabled() {
                return this.validate()
            },

            userInfo() {
              return this.$store.state.settings.userInfo
          },


    
          hasEmail() {
              return !!this.userInfo.contacts.email
          },
        },

        data() {
            return {
                newEmail: '',
                newEmailRules: [
                    v => !!v || 'Введите адрес электронной почты',
  /*                   v => !this.email || (!!this.email && this.email != v) ||
                    'Новый адрес электронной почты не должен совпадать с текущим', */
                    v =>
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    .test(v) || 'Введите корректный адрес электронный почты'
                ],

            }
        },

        methods: {

            validate() {
                return this.newEmailRules.every(rule => rule(this.newEmail) === true)
            },

            goBack() {
                this.$router.back()
            },

            startChangeEmail() {

                if (!this.validate()) return

                this.changeEmail(this.newEmail, '', false, () => {
                    this.$router.push({
                        name: 'wv-settings-email-confirm',
                        params: {
                            email: this.newEmail
                        }
                    })
                })
            },


        },


    }
</script>

<style>

</style>